import { render, staticRenderFns } from "./ZjLogin.vue?vue&type=template&id=7bfd67cc&scoped=true&"
import script from "./ZjLogin.vue?vue&type=script&lang=js&"
export * from "./ZjLogin.vue?vue&type=script&lang=js&"
import style0 from "./ZjLogin.vue?vue&type=style&index=0&id=7bfd67cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd67cc",
  null
  
)

export default component.exports